import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService } from 'tnx-shared';

@Injectable({
    providedIn: 'root',
})
export class ScheduleTriggerService extends BaseService {
    entityName = 'ScheduleTrigger';
    serviceCode = 'schedule';

    constructor(http: HttpClient, injector: Injector,
                private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
        this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    async changeTriggerStatus(id: string, type: number) {
        const url = `${this.serviceUri}/ChangeTriggerStatus?id=${id}&type=${type}`;
        return this.defaultPost(url, null);
    }
}
